import { Button, type ButtonProps, Drawer, Modal } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import { useWindowWidth } from '@/hooks/useWindowWidth';
import { cn } from '@/lib/cn';

export const Modrawer = ({
  open,
  cancelText,
  okText,
  width,
  height,
  cancelButtonProps,
  okButtonProps,
  onCancel,
  onOk,
  title,
  children,
  footer,
  footerWrapperClassname,
  full = false,
  breakpoint = 768
}: {
  open: boolean;
  okText?: React.ReactNode;
  cancelText?: React.ReactNode;
  width?: number;
  height?: number;
  onCancel?: () => void;
  onOk?: () => void;
  title?: React.ReactNode;
  children?: React.ReactNode;
  cancelButtonProps?: ButtonProps;
  footerWrapperClassname?: string;
  okButtonProps?: ButtonProps;
  footer?: React.ReactNode;
  full?: boolean;
  breakpoint?: number;
}) => {
  const windowWidth = useWindowWidth();

  if (windowWidth > breakpoint) {
    return (
      <Modal
        cancelButtonProps={cancelButtonProps}
        okButtonProps={okButtonProps}
        open={open}
        okText={okText}
        cancelText={cancelText}
        width={width}
        height={height}
        onCancel={onCancel}
        onOk={onOk}
        title={title}
        footer={footer}
        closeIcon={<Icon.X id='modrawer-close-button' />}
      >
        {children}
      </Modal>
    );
  }

  return (
    <Drawer
      title={title}
      placement='bottom'
      width={width || '100%'}
      onClose={onCancel}
      // eslint-disable-next-line eduzz-rules/jsx-valid-id
      closeIcon={<Icon.X id='modrawer-close-button' />}
      open={open}
      classNames={{ header: '[&_.ant-drawer-header-title]:flex-row-reverse' }}
      styles={{
        content: { padding: 0 },
        body: {
          padding: 24,
          maxHeight: 'none',
          overflow: 'visible'
        }
      }}
      height={full ? '100%' : 'auto'}
    >
      <div className='flex h-full flex-1 flex-col'>
        {children}
        <div className='flex flex-1'></div>
        {footer && <div className='mt-4'>{footer}</div>}
        {!footer && (
          <div className={cn('mt-4 flex justify-end gap-2', footerWrapperClassname)}>
            <Button
              id='cancel'
              variant='filled'
              color='default'
              type='default'
              onClick={onCancel}
              {...cancelButtonProps}
            >
              {cancelText || 'Cancel'}
            </Button>

            <Button id='ok' type='primary' onClick={onOk} {...okButtonProps}>
              {okText || 'OK'}
            </Button>
          </div>
        )}
      </div>
    </Drawer>
  );
};
